import { Component, input, output } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatButtonToggleModule } from '@angular/material/button-toggle';
import { MatIconModule } from '@angular/material/icon';
import { MatMenuModule } from '@angular/material/menu';
import { TranslateModule } from '@ngx-translate/core';

import { DropdownActionsEnum } from '@shared/consts';
import { SaveButtonActionEvent, SaveButtonActions, SaveButtonCustomAction, SaveButtonType } from './common';

@Component({
  selector: 'cipo-save-button',
  templateUrl: './save-button.component.html',
  styleUrls: ['./save-button.component.scss'],
  imports: [TranslateModule, MatMenuModule, MatIconModule, MatButtonModule, MatButtonToggleModule],
})
export class SaveButtonComponent {
  SAVE_BUTTON_ACTIONS = SaveButtonActions;
  SAVE_BUTTON_TYPE = SaveButtonType;

  type = input<SaveButtonType>(SaveButtonType.OnlySave);
  disable = input<boolean>(false);
  saveLabel = input<string>('general.save');
  /** For custom actions (ex: transitions, screen type etc) */
  customActions = input<SaveButtonCustomAction[]>([]);

  saveEvent = output<SaveButtonActions>();
  /** this only emits the custom action id on click */
  actionEvent = output<SaveButtonActionEvent>();
  DropdownActionsEnum = DropdownActionsEnum;

  actionClicked(id: number, submenu?: SaveButtonActionEvent) {
    this.actionEvent.emit({ id, submenu });
  }
}
